import type { PanelInterviewRegistrationId } from "@/backend/db/drizzle/types/idTypes";
import { getInterviewPath } from "@/lib/interview/links";
import { zodBrandedUuid } from "@/utils/helpers";
import type { SearchParamsSync } from "@/utils/types";

/** Our only param on the link; the rest is read from the registration. */
export const PANEL_API_INTERVIEW_PARAM = "__interview_id";

const interviewIdZod = zodBrandedUuid<PanelInterviewRegistrationId>();

export type PanelApiInterviewParam =
  | { kind: "absent" }
  // empty, repeated or not a uuid; fails closed
  | { kind: "malformed" }
  | { kind: "present"; interviewId: PanelInterviewRegistrationId };

export const readPanelApiInterviewParam = (
  searchParams: SearchParamsSync
): PanelApiInterviewParam => {
  const value = searchParams?.[PANEL_API_INTERVIEW_PARAM];
  if (value === undefined) return { kind: "absent" };
  const parsed = interviewIdZod.safeParse(value);
  return parsed.success
    ? { kind: "present", interviewId: parsed.data }
    : { kind: "malformed" };
};

export const buildPanelApiInterviewUrl = ({
  origin,
  linkId,
  interviewId,
  groupUrlParams,
}: {
  origin: string;
  linkId: string;
  interviewId: PanelInterviewRegistrationId;
  groupUrlParams?: Record<string, string>;
}): string => {
  const url = new URL(`${origin}${getInterviewPath(linkId)}`);
  for (const [key, value] of Object.entries(groupUrlParams ?? {})) {
    url.searchParams.set(key, value);
  }
  // last, so a researcher's url_params cannot displace it
  url.searchParams.set(PANEL_API_INTERVIEW_PARAM, interviewId);
  return url.toString();
};
